// tslint:disable
export var CampaignOptType;
(function (CampaignOptType) {
    // UNKN
    CampaignOptType[CampaignOptType["UNKN"] = 10001] = "UNKN";
    // OPTI
    CampaignOptType[CampaignOptType["OPTI"] = 10002] = "OPTI";
    // OPTO
    CampaignOptType[CampaignOptType["OPTO"] = 10003] = "OPTO";
})(CampaignOptType || (CampaignOptType = {}));
//# sourceMappingURL=CampaignOptType.js.map